import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { useDesiredOutcomeContext } from './Context';
import Content from './Content';

const DesiredOutcomes = () => {
  const { initializingError, isInitializing } = useDesiredOutcomeContext();
  return (
    <DataContainer
      component={Content}
      loading={isInitializing}
      loadingError={initializingError}
    />
  );
};

DesiredOutcomes.propTypes = {
};

export default DesiredOutcomes;
